import { Box } from "@mui/system";
import React from "react";
import { Typography } from "@mui/material";
import { useTheme } from "@emotion/react";

import CustomAvatar from "../CustomAvatar";
import RightLeftChecker from "../../../utils/RightLeftChecker";

const Replayed = ({ cmData }) => {
  const theme = useTheme();

  const handleDisableClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };
  return (
    <Box
      onClick={handleDisableClick}
      onContextMenu={handleDisableClick}
      sx={{ display: "flex", alignItems: "center" }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box
          sx={{
            backgroundColor: "secondary.main",
            width: "2px",
            height: "27px",
            borderRadius: "1px",
          }}
        ></Box>
        <Box sx={{ mr: "6px", ml: "4px" }}>
          <CustomAvatar
            borderSize={1.5}
            src={cmData.parent_comment_data.author.avatar}
            size={24}
            round='4px'
            alt={"avatar name"}
            borderColor={theme.palette.white.main}
          />
        </Box>
      </Box>
      <Box sx={{ width: "82%" }}>
        <Typography
          sx={{
            fontSize: "11px",
            fontWeight: "600",
            lineHeight: "14px",
            color: "secondary.main",
          }}
        >
          {cmData.parent_comment_data.author.nickname}
        </Typography>
        <Typography
          // noWrap
          sx={{
            fontSize: "10px",
            lineHeight: "14px",
            mt: "auto",
            color: `black.main`,
            direction: RightLeftChecker(cmData.parent_comment_data.text)
              ? "rtl"
              : "ltr",
            wordWrap: " break-word",
          }}
        >
          {cmData.parent_comment_data.text}
        </Typography>
      </Box>
    </Box>
  );
};

export default Replayed;
